export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  const localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  const day = localDate.getDate();
  const month = localDate.getMonth() + 1;
  const year = localDate.getFullYear();
  return `${padZero(day)}/${padZero(month)}/${year}`;
}

export function formatDateTime(dateTimeString: string | null): string {
  if (!dateTimeString) return '';

  const dateTime = new Date(dateTimeString);
  const day = dateTime.getUTCDate(); 
  const month = dateTime.getUTCMonth() + 1; 
  const year = dateTime.getUTCFullYear(); 
  const hours = dateTime.getUTCHours(); 
  const minutes = dateTime.getUTCMinutes(); 

  return `${padZero(day)}/${padZero(month)}/${year} ${padZero(hours)}:${padZero(minutes)}`;
}


export function padZero(num: number): string {
  return num.toString().padStart(2, "0");
}
